import { render } from "./CalculatorSelector.vue?vue&type=template&id=bafcee06&scoped=true"
import script from "./CalculatorSelector.vue?vue&type=script&lang=js"
export * from "./CalculatorSelector.vue?vue&type=script&lang=js"

import "./CalculatorSelector.vue?vue&type=style&index=0&id=bafcee06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bafcee06"]])

export default __exports__